module.exports = __webpack_public_path__ + "img/1.07cfd27f.svg";